import { render, staticRenderFns } from "./RiskSurveySafeRoom.vue?vue&type=template&id=ec8b4c9a&"
import script from "./RiskSurveySafeRoom.vue?vue&type=script&lang=js&"
export * from "./RiskSurveySafeRoom.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveySafeRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports